import { AvailableMetric } from '@spotify/confidence-editor-react';

export const getColorClass = (
  status: string | undefined,
  metricType: 'guardrail' | 'success',
  hasNoninferiorityMargin?: boolean,
): string => {
  if (!status) return 'unclear';

  switch (status) {
    case 'METRIC_RESULT_STATUS_DESIRED_SIGNIFICANT':
      return 'good';
    case 'METRIC_RESULT_STATUS_UNDESIRED_SIGNIFICANT':
      return 'bad';
    case 'METRIC_RESULT_STATUS_NOT_SIGNIFICANT': {
      if (metricType === 'guardrail' && !hasNoninferiorityMargin) {
        return 'good';
      }
      if (metricType === 'success') {
        return 'unclear';
      }
      return 'warn';
    }
    case 'METRIC_RESULT_STATUS_DESIRED_AND_UNDESIRED_SIGNIFICANT':
      return 'warn';
    default:
      return 'unclear';
  }
};

export const isMetricStale = (
  stored: {
    value: string;
    sampleSize: string;
    lowerBound: string;
    upperBound: string;
    status?: string;
    type?: 'guardrail' | 'success';
    hasNoninferiorityMargin?: boolean;
  },
  available: AvailableMetric,
): boolean => {
  if (stored.value !== (available.value || '—')) return true;
  if (stored.sampleSize !== (available.sampleSize?.toLocaleString() || '—'))
    return true;
  if (stored.lowerBound !== (available.lowerBound || '—')) return true;
  if (stored.upperBound !== (available.upperBound || '—')) return true;
  if ((stored.status || undefined) !== (available.status || undefined))
    return true;
  if (
    (stored.type === 'guardrail' || stored.type === 'success') &&
    stored.type !== available.type
  )
    return true;
  if (
    stored.hasNoninferiorityMargin !== undefined &&
    stored.hasNoninferiorityMargin !==
      (available.hasNoninferiorityMargin ?? false)
  )
    return true;
  return false;
};
